import {
  UPDATE_SUB_CATEGORY,
  UPDATE_SUB_CATEGORY_FAILURE,
  UPDATE_SUB_CATEGORY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateSubCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SUB_CATEGORY:
      return { ...state, loading: true };
    case UPDATE_SUB_CATEGORY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_SUB_CATEGORY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateSubCategoryReducer;
